// extracted by mini-css-extract-plugin
export default {"title":"UsersTable_title__GB8sq","tableHeader":"UsersTable_tableHeader__5of6A","downloadButton":"UsersTable_downloadButton__82f4x"};